import { Languages, Locale } from '@frontend/common';
import { useLocale } from '@frontend/lang';
import { useEffect, useState } from 'react';

export interface LanguageSelectModalProps {
    onClose: () => void;
}

interface ViewProps {
    options: { value: Locale; displayName: string }[] | null;
    selected: { value: Locale; displayName: string } | null;
    setSelected: (value: { value: Locale; displayName: string } | null) => void;
    isLoading: boolean;
    submitDisabled?: boolean;
    onSubmit: () => void;
    currentLocale?: Locale;
}

const useLanguageSelectModal = (props: LanguageSelectModalProps): ViewProps => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selected, setSelected] = useState<{ value: Locale; displayName: string } | null>(null);
    const { locale, changeLocale, availableLanguages } = useLocale();
    const [options, setOptions] = useState<{ value: Locale; displayName: string }[] | null>(availableLanguages ?? Languages);

    useEffect(() => {
        setOptions(availableLanguages ?? Languages);
    }, [availableLanguages]);

    useEffect(() => {
        if (locale) {
            const found = Languages.find((l) => l.value === locale);
            if (found) setSelected(found);
        }
    }, [locale]);

    const onSubmit = async () => {
        if (!selected) return;
        setIsLoading(true);
        changeLocale(selected.value);
        props.onClose();
        setIsLoading(false);
    };

    return {
        options,
        selected,
        setSelected,
        isLoading,
        submitDisabled: selected === null || isLoading || locale === selected?.value,
        onSubmit,
        currentLocale: locale
    };
};

export default useLanguageSelectModal;
